import {createStore, applyMiddleware} from 'redux'
import rootReducers from '../reducers/root.reducer'
import thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'

export default createStore(rootReducers, composeWithDevTools(
  applyMiddleware(thunk),
))
